var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTracking({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 24,
    viewBox: "0 0 52 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8018_12295",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    width: 24,
    height: 24,
    fill: "#6785EA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8018_12295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 20C19.1667 20 18.4583 19.7083 17.875 19.125C17.2917 18.5417 17 17.8333 17 17H15V6C15 5.45 15.1958 4.97917 15.5875 4.5875C15.9792 4.19583 16.45 4 17 4H31V8H34L37 12V17H35C35 17.8333 34.7083 18.5417 34.125 19.125C33.5417 19.7083 32.8333 20 32 20C31.1667 20 30.4583 19.7083 29.875 19.125C29.2917 18.5417 29 17.8333 29 17H23C23 17.8333 22.7083 18.5417 22.125 19.125C21.5417 19.7083 20.8333 20 20 20ZM20 18C20.2833 18 20.5208 17.9042 20.7125 17.7125C20.9042 17.5208 21 17.2833 21 17C21 16.7167 20.9042 16.4792 20.7125 16.2875C20.5208 16.0958 20.2833 16 20 16C19.7167 16 19.4792 16.0958 19.2875 16.2875C19.0958 16.4792 19 16.7167 19 17C19 17.2833 19.0958 17.5208 19.2875 17.7125C19.4792 17.9042 19.7167 18 20 18ZM32 18C32.2833 18 32.5208 17.9042 32.7125 17.7125C32.9042 17.5208 33 17.2833 33 17C33 16.7167 32.9042 16.4792 32.7125 16.2875C32.5208 16.0958 32.2833 16 32 16C31.7167 16 31.4792 16.0958 31.2875 16.2875C31.0958 16.4792 31 16.7167 31 17C31 17.2833 31.0958 17.5208 31.2875 17.7125C31.4792 17.9042 31.7167 18 32 18ZM31 13H35.25L33 10H31V13Z",
    fill: "#FF7B2E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracking);
export default __webpack_public_path__ + "static/media/tracking.8b408b0889ec3584d71a29e9643651b2.svg";
export { ForwardRef as ReactComponent };